import { render, staticRenderFns } from "./FloatingTitleLayout.vue?vue&type=template&id=4e95448f"
import script from "./FloatingTitleLayout.vue?vue&type=script&lang=js"
export * from "./FloatingTitleLayout.vue?vue&type=script&lang=js"
import style0 from "./FloatingTitleLayout.vue?vue&type=style&index=0&id=4e95448f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports